module.exports = __webpack_public_path__ + "static/media/top_infographic_mobile.cd4d9f58.webp";